<template>
  <div>
    <div v-if="!loading">
      <h2 v-if="error">
        {{ error }}
      </h2>
      <div v-else>
        <h2>Campus Graduate Progress</h2>
        <div v-if="isOneOfTheseRoles(['ad'])">
          <h4>Totals:</h4>
          <ul>
            <li>Total seniors involved: {{ totals.total_records }}</li>
            <li>
              Seniors who have been marked as either graduating, not graduating, or "not sure":
              {{ totals.designated_records }}
            </li>
            <li>Graduating seniors: {{ totals.graduating_seniors }}</li>
            <li>Graduating seniors with completed information: {{ totals.completed_graduating_seniors }}</li>
          </ul>
        </div>
        <el-table
          :data="table"
          style="width: 100%"
        >
          <el-table-column
            prop="campus"
            label="Campus"
          >
          </el-table-column>
          <el-table-column
            prop="col1"
            label="Seniors marked as graduating or not"
          >
          </el-table-column>
          <el-table-column
            prop="col2"
            label="Graduating seniors with completed info"
          >
          </el-table-column>
          <el-table-column
            prop="vocations"
            label="Vocations"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <h5 v-if="loading" style="text-align:center">
      Loading...
    </h5>
  </div>
</template>

<script>
import graduationRecordsRepository from '../../repositories/graduationRecordsRepository';

export default {
    created() {
        this.getGradRecordsTable();
    },
    data() {
        return {
            loading: false,
            table: '',
            error: null,
            totals: {
                total_records: 0,
                designated_records: 0,
                graduating_seniors: 0,
                completed_graduating_seniors: 0
            }
        };
    },
    methods: {
        getGradRecordsTable() {
            this.loading = true;
            graduationRecordsRepository.getGradRecordsTable()
                .then((response) => {
                    this.table = response.data.table;
                    this.calculateRatios();
                    this.getTotals();
                    this.loading = false;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    this.loading = false;
                });
        },
        calculateRatios() {
            this.table.forEach((row) => {
                // eslint-disable-next-line
                const col1percentage = row.total_records === 0 ? 0 : Math.round((row.designated_records / row.total_records) * 100);
                // eslint-disable-next-line
                const col2percentage = row.graduating_seniors === 0 ? 0 : Math.round((row.completed_graduating_seniors / row.graduating_seniors) * 100);
                row.col1 = `${col1percentage}% (${row.designated_records}/${row.total_records})`;
                row.col2 = `${col2percentage}% (${row.completed_graduating_seniors}/${row.graduating_seniors})`;
            });
        },
        getTotals() {
            this.table.forEach((row) => {
                this.totals.total_records += row.total_records;
                this.totals.designated_records += row.designated_records;
                this.totals.graduating_seniors += row.graduating_seniors;
                this.totals.completed_graduating_seniors += row.completed_graduating_seniors;
            });
        }
    }

};
</script>
